import React from "react";
import { Breadcrumbs } from "../breadcrumb";

const crumbs = ["Delivery", "Review", "Payment"] as const;
export type OrderBreadcrumbsProps = {
  selectedCrumb: (typeof crumbs)[number];
};
export const OrderBreadcrumbs = ({
  selectedCrumb,
}: OrderBreadcrumbsProps): React.ReactElement => {
  return <Breadcrumbs crumbs={crumbs} selectedCrumb={selectedCrumb} />;
};
